// extracted by mini-css-extract-plugin
export default {"preview":"register_preview__+SCD2"};